var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center"},[_c('b-img',{staticClass:"image-banner",staticStyle:{"max-height":"150px !important"},attrs:{"src":_vm.url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }